import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * GET /api/v1/queries/telemetry/payload-analytics/summary
     * Painel do período.
     */
    fetchSummary(ctx, queryParams) {
      const {
        assetId,
        startDate,
        endDate,
        nominalCapacity,
        excludeLowConfidence,
      } = queryParams

      const params = {
        assetId,
        startDate,
        endDate,
      }

      if (nominalCapacity !== null && nominalCapacity !== undefined && nominalCapacity !== '' && Number(nominalCapacity) > 0) {
        params.nominalCapacity = Number(nominalCapacity)
      }

      if (excludeLowConfidence === true || excludeLowConfidence === 'true') {
        params.excludeLowConfidence = true
      }

      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/queries/telemetry/payload-analytics/summary', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    /**
     * GET /api/v1/queries/telemetry/payload-analytics/cycles
     * Lista completa, histograma e praças de carregamento/descarregamento (150m).
     */
    fetchCycles(ctx, queryParams) {
      const {
        assetId,
        startDate,
        endDate,
        nominalCapacity,
        excludeLowConfidence,
      } = queryParams

      const params = {
        assetId,
        startDate,
        endDate,
      }

      if (nominalCapacity !== null && nominalCapacity !== undefined && nominalCapacity !== '' && Number(nominalCapacity) > 0) {
        params.nominalCapacity = Number(nominalCapacity)
      }

      if (excludeLowConfidence === true || excludeLowConfidence === 'true') {
        params.excludeLowConfidence = true
      }

      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/queries/telemetry/payload-analytics/cycles', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    /**
     * GET /api/v1/queries/telemetry/payload-analytics/details
     * Lista paginada dos ciclos para a tabela detalhada.
     */
    fetchDetails(ctx, queryParams) {
      const {
        assetId,
        startDate,
        endDate,
        nominalCapacity,
        excludeLowConfidence,
        page = 1,
        perPage = 10,
      } = queryParams

      const params = {
        assetId,
        startDate,
        endDate,
        page,
        perPage,
      }

      if (nominalCapacity !== null && nominalCapacity !== undefined && nominalCapacity !== '' && Number(nominalCapacity) > 0) {
        params.nominalCapacity = Number(nominalCapacity)
      }

      if (excludeLowConfidence === true || excludeLowConfidence === 'true') {
        params.excludeLowConfidence = true
      }

      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/queries/telemetry/payload-analytics/details', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    /**
     * Busca metadados do ativo por ID
     */
    fetchAsset(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/Asset?id=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    /**
     * Busca ativos para o seletor rápido (caso rota não receba ID)
     */
    fetchAssets(ctx, queryParams = {}) {
      const { q = '', page = 1, perPage = 20 } = queryParams
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/Asset/search?Search=${encodeURIComponent(q)}&Page=${page}&PerPage=${perPage}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
